import { css } from '@emotion/react'
import styled from '@emotion/styled'

export const OrderMobileContent = styled.div`
  background-color: ${({ theme }) => theme.colors.neutrals.w};
`

export const SummaryContent = styled.div`
  ${({ theme }) => `
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid ${theme.colors.grey[2]};
    padding: 14px 16px;
    cursor: pointer;
  `}
`

export const EndContent = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

export const ArtImageContent = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`

export const Text = styled.p`
  ${({ theme }) => css(theme.typographys.small.regular)};
  color: ${({ theme }) => theme.colors.grey[5]};
`

export const CircleImage = styled.div`
  width: 24px;
  height: 24px;
  border-radius: 16px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ theme }) => theme.colors.grey[1]};
`

export const OderPurchaseTitle = styled.div`
  border-top: 1px solid ${({ theme }) => theme.colors.grey[2]};
  text-align: center;
  padding: 20px 0;
`

export const OrderPurchaseItem = styled.div`
  border-bottom: 1px solid ${({ theme }) => theme.colors.grey[2]};
  margin-bottom: 26px;
  padding-bottom: 26px;

  &:last-child {
    border-bottom: none;
    padding-bottom: 0;
  }
`

export const OrderPurchaseTitleItem = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  border: 1px solid ${({ theme }) => theme.colors.grey[2]};
  border-radius: 4px;
  padding: 8px;
`

export const OrderPurchaseDate = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 8px;
`

export const OrderPurchaseDepartureArrival = styled.div`
  display: flex;
  justify-content: center;
  padding: 8px 0 10px 0;
`

export const OrderPurchaseDepartureArrivalSeparator = styled.div`
  border-top: 1px solid ${({ theme }) => theme.colors.grey[2]};
  margin: 8px 12px 0 12px;
  width: 10px;
`

export const OrderPurchaseDetailsArrival = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`
